var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-permission",staticStyle:{"background-color":"#f6f8fa"}},[_c('div',{staticClass:"content"},[_c('el-row',{attrs:{"justify":"center"}},[_c('el-image',{attrs:{"src":"/static/images/No_Permission1.png","alt":"No Permission"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"2rem","text-align":"center"}},[_vm._v("您暂无访问权限")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa5787d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/no.vue
// module id = null
// module chunks = 